import { ApiKeyData } from '@x/types';
import { ApiMutationConfig, ApiQueryConfig } from 'api/types';
import { createApiEndpoint } from 'api/utils';
import { URLS } from 'config';

type GetApiKeysConfig = ApiQueryConfig<ApiKeyData[]>;
type PostApiKeysConfig = ApiMutationConfig<ApiKeyData>;
type DeleteApiKeysConfig = ApiMutationConfig<unknown, { $apiKeyId: number }>;

const url = `${URLS.app}/api/OrganizationApiKeys`;

export const getApiKeys = createApiEndpoint<GetApiKeysConfig>({
  method: 'GET',
  url,
  cacheTime: 1000 * 60 * 60, // virtually never changes
  staleTime: 1000 * 60 * 60,
});

export const postApiKey = createApiEndpoint<PostApiKeysConfig>({
  method: 'POST',
  url,
});

export const delApiKey = createApiEndpoint<DeleteApiKeysConfig>({
  method: 'POST',
  url: `${url}/DeleteApiKey/$apiKeyId`,
});
